import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { identifierModuleUrl } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { ObsidiamJweComponent } from 'projects/obsidiam-jwe/src/public-api';
@Directive()
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn: any = false;
  ApiUrl: any = environment.apiUrl + 'user/';
  isDeletedDispute: any = false;
  @Output() deletedDisputeEvent: EventEmitter<boolean> = new EventEmitter();

  constructor(private http: HttpClient,
    private obsidiamJweComponent: ObsidiamJweComponent,
    private cookieService: CookieService
  ) {
    const cookieData = this.cookieService.get('OBSIDIAM-ADIMIN-AUTH');
    if (cookieData) {
      this.isLoggedIn = true;
    }
  }
  convertTimeToCuraco(time) {
    if (time) {
      return new Date((new Date(time)).toUTCString()).toLocaleString(undefined, { timeZone: 'America/Curacao' });
    }
    return '';
  }
  deleteDisputeEvent() {
    this.isDeletedDispute = !this.isDeletedDispute;
    this.deletedDisputeEvent.emit(this.isDeletedDispute);
  }
  getLoggedData() {
    const cookieData: any = this.cookieService.get('OBSIDIAM-ADIMIN-AUTH');
    return cookieData ? JSON.parse(cookieData) : {};
  }
  login(data) {
    // return this.http.post(this.ApiUrl + 'admin/login', data);
    const headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.obsidiamJweComponent.mapObservable(this.http.post(this.ApiUrl + 'admin/login-admin-users-bb', data,{headers, responseType: 'text' }));

  }
  verify(data) {
    // return this.http.post(this.ApiUrl + 'admin/verify-authy-login', data);
    const headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.obsidiamJweComponent.mapObservable(this.http.post(this.ApiUrl + 'admin/verify-authy-login-bb', data,{headers, responseType: 'text' }));

  }

  getAccountUsers(): any {
    return this.http.get(this.ApiUrl + 'admin/get-blue-bank-users');
    // return this.http.get('https://run.mocky.io/v3/50f85446-31e7-4ed7-89da-fc5b47558cd8', {});
    // https://designer.mocky.io/manage/delete/50f85446-31e7-4ed7-89da-fc5b47558cd8/YPtsBrewEEMkCQrtYGsGrPMRdNF2S1kjmKvE
    // {
    //     "status": 200,
    //     "message": "Verification successful",
    //     "timestamp": "2022-03-25T08:53:52.005+00:00",
    //     "data": [{"id": "128374","name":"Sonia","email":"sonia123@gmail.com","registrationDate":"01/03/2021","account_dollar":"233","account_euro":"456","reason":"","status":"Pending"},{"id": "128374","name":"Carlos Yanez","email":"carlos222@gmail.com","registrationDate":"21/06/2021","account_dollar":"12","account_euro":"23","reason":"N/A","status":"Approved"},{"id": "98765","name":"Sachin Gupta","email":"tasacsachin@gmail.com","registrationDate":"13/02/2022","account_dollar":"34","account_euro":"78","reason":"Does not accomplished the requirenments","status":"Rejected"}]
    //   }
  }
  updateAccountUsers(data): any {
    return this.http.post(this.ApiUrl + 'admin/approve-blue-bank-user', data);

  }
  getAccess() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(this.ApiUrl + 'admin/get-access', { headers });
  }
  bulkMailhistory(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(this.ApiUrl + 'admin/get-mail-history?pageNo=' + p + '&size=' + ps, { headers });
  }
  getUsers(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(this.ApiUrl + 'admin/get-users?pageNo=' + p + '&size=' + ps, { headers });
  }
  getAdminUsers() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(this.ApiUrl + 'admin/get-admins', { headers });
  }
  getVerificationCounts() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/admin/get-verification-count', { headers });
  }
  getAllAdminUsers() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(this.ApiUrl + 'admin/get-admin-users', { headers });
  }
  updateAdminStatus(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/update-admin-status', data, { headers });
  }

  createAdmin(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/create-admin', data, { headers });
  }
  addCurrencyAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/simplex/add-currency', data, { headers });
  }
  deleteCurrencyAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/simplex/delete-currency', data, { headers });
  }
  verifyUser(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/verify-user', data, { headers });
  }
  updateAdmin(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/update-admin', data, { headers });
  }

  updateUserStatus(data, type) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/' + type, data, { headers });
  }
  getNetVerifyLink(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/create-netverify-link', data, { headers });
  }
  getIp() {
    return this.http.get('https://ipapi.co/json');
  }
  getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
  updateAdminPassword(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/update-admin-password', data, { headers });
  }
  sendBulkMail(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/send-bulk-mail', data, { headers });
  }
  updateAdminAccess(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(this.ApiUrl + 'admin/update-access', data, { headers });
  }
  geetestRegister() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(this.ApiUrl + 'gt/register?t=t');
  }
  getWalletDetail() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/admin/get-wallet-details', { headers });
  }
  getReferralSetting() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/referral/get-settings', { headers });
  }
  updateFailedLoginBlockAccount(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'user/admin/update-failed-attempt-to-block-account?failedLoginBlockAccount=' + data.failedLoginBlockAccount + '&verificationCode=' + data.verificationCode, {}, { headers });
  }
  gerCryptos() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/admin/cryptos', { headers });
  }
  getTotalEarning() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/referral/get-total-earning', { headers });
  }
  enableDisableCoin(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/enable-disable-wallet', data, { headers });
  }
  updateBanaxa(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/banxa-admin/update-banxa-status', data, { headers });
  }
  updateBuySell(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/enable-disable-buysell', data, { headers });
  }
  updateReferralSettings(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'user/referral/update-settings', data, { headers });
  }
  updateCrypto(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/add-update-cryptos', data, { headers });
  }
  hitWithdrawFeeValidateAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/check-fee-equation', data, { headers });
  }
  updateSettings(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'ethereum/admin/update-setting', data, { headers });
  }
  updateContract(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'ethereum/admin/add-update-contract', data, { headers });
  }
  addMarket(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/add-market', data, { headers });
  }
  updateStepSize(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/update-step-size', data, { headers });
  }
  updateReferralStatus(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'user/referral/update-status', data, { headers });
  }
  updateConfirmationsAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/update-confirmations', data, { headers });
  }
  updateWithdrawalLimit(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/update-withdraw-limit', data, { headers });
  }
  updateWalletLimit(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/update-hot-wallet-limit', data, { headers });
  }
  getQuickTransferHistory(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'quick-transfer/admin/get-quick-transfer-history?pageNo=' + p + '&size=' + ps, { headers });
  }
  getFeeLimitUpdationHistory(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'quick-transfer/admin/get-fee-limit-updation-history?pageNo=' + p + '&size=' + ps, { headers });
  }
  getExchangeFeeUpdationHistory(feeUpdateType, p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/admin/fee-updation-history?pageNo=' + p + '&size=' + ps + '&feeUpdateType=' + feeUpdateType, { headers });
  }
  getSettingUpdationHistory(settingUpdateType, p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/liquidity/setting-updation-history?pageNo=' + p + '&size=' + ps + '&settingType=' + settingUpdateType, { headers });
  }
  getQuickTransferLimit() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'quick-transfer/admin/get-limit', { headers });
  }
  updateQuickTransferLimit(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'quick-transfer/admin/update-limit', data, { headers });
  }
  getLiquidityConditionHistory(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'liquidity/liquidity-user-coin-condition-history', data, { headers });
  }
  getLiquidityUpdationHistory(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/admin/liquidity-updation-history?pageNo=' + data.pageNo + '&size=' + data.size, { headers });
  }
  updateExchangeFee(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/update-fee', data, { headers });
  }
  updateLiquiditySetting(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/liquidity/update-liquidity-setting', data, { headers });
  }
  updateExchangeVolume(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/update-volume-status', data, { headers });
  }
  updateStatusOfMarket(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/enable-disable-market', data, { headers });
  }
  updateLiquidityStatus(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/update-liquidity-status', data, { headers });
  }
  updateBinanceLiquidityStatus(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/liquidity/update-binance-liquidity-status', data, { headers });
  }
  updateBinanceLiquidityFeeStatus(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/liquidity/update-binance-liquidity-fee-status', data, { headers });
  }
  triggerWithdrawAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/liquidity/trigger-liquidity-withdraw?verificationCode=' + data, { headers });
  }
  getStaticContent(lang) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', lang || loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'static-content/admin/get-content-list?language=' + (lang || 'en'), { headers });
  }
  getStaticContentHistory(lang, content) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', lang || loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'static-content/admin/get-content-list-history?type=' + content.contentType, { headers });
  }

  getTeamList() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'static-content/get-team');
  }
  createTeamMember(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'static-content/admin/add-team-member', data, { headers });
  }
  deleteTeamMember(id) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'static-content/admin/delete-member?id=' + id, {}, { headers });
  }
  createUpdateContent(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', data.language || loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'static-content/admin/update-content', data, { headers });
  }
  getAnnouncements(p, ps, lang) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.get(environment.apiUrl + 'static-content/get-announcements?pageNo=' + p + '&size=' + ps + '&language=' + lang, { headers });
  }
  addPostAnnouncement(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'static-content/admin/post-announcement', data, { headers });
  }
  updateAnnouncement(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'static-content/admin/update-announcement', data, { headers });
  }
  deleteAnnouncement(id) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'static-content/admin/delete-announcement?id=' + id, { headers });
  }
  getFeeData() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/fee', { headers });
  }
  getSettingLiquidity() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'liquidity/settings', { headers });
  }
  getFutureAccessAmount() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/liquidity/futures-excess-amount', { headers });
  }
  getLiquidityCoinCondition() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'liquidity/liquidity-user-coin-condition', { headers });
  }
  getMarketData() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/get-market', { headers });
  }
  getliquidityPriceEquationData() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'liquidity/liquidity-setting', { headers });
  }
  getLiquidityWeightData() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/liquidity/weight-ratio', { headers });
  }
  getLiquidityUserId() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'liquidity/liquidity-user-id', { headers });
  }
  // Dispute management
  getDisputeOrders(status, p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.get(environment.apiUrl + 'otc/dispute/get-orders?disputeStatus=' + status + '&pageNo=' + p + '&size=' + ps, { headers });
  }
  getNotifications(status, p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.get(environment.apiUrl + 'user/admin/get-notifications?pageNo=' + p + '&seenStatus=' + status + '&size=' + ps, { headers });
  }

  takeOrder(id) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.get(environment.apiUrl + 'otc/dispute/take-order?orderActionId=' + id, { headers });
  }
  tradeWindowDetail(orderId) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.get(environment.apiUrl + 'otc/dispute/get-trade-window-details?orderActionId=' + orderId, { headers });
  }
  getDisputeComments(orderId) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.get(environment.apiUrl + 'otc/dispute/get-comments?orderActionId=' + orderId, { headers });
  }
  addDisputeComent(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'otc/dispute/add-comment', data, { headers });
  }
  updateLiquidityPriceEquation(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'liquidity/update-liquidity-price-equation', data, { headers });
  }
  updateLiquidityPriceRangePercentage(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/update-liquidity-price-range-percentage', data, { headers });
  }
  updateLiquidityWeightData(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/liquidity/update-weight-ratio', data, { headers });
  }
  getMessages(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'otc/get-messages', data, { headers });
  }
  getMessagesCount(orderActionId) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/get-message-count?orderActionId=' + orderActionId, { headers });
  }
  sendMessage(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'otc/send-message', data, { headers });
  }
  resolveDispute(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'otc/dispute/resolve-dispute', data, { headers });
  }
  uploapDocument(data, progress = true) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token)
      // .set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage||'en');
      // .set('Content-Type', 'multipart/form-data;')
      .set('Accept', 'application/json');
    // console.log(data);
    if (progress) {
      return this.http.post(environment.apiUrl + 'otc/upload-doument', data,
        { headers, reportProgress: true, observe: 'events' }).pipe(map((event) => {

          switch (event.type) {

            case HttpEventType.UploadProgress:
              const p = Math.round(100 * event.loaded / event.total);
              return { status: 'progress', message: p };

            case HttpEventType.Response:
              return event.body;
            default:
              console.log(`Unhandled event: ${event.type}`);
              return {};
          }
        })
        );
    } else {
      return this.http.post(environment.apiUrl + 'otc/upload-doument', data, { headers });
    }
  }
  // Buy  Sell
  getMarketOrders(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.post(environment.apiUrl + 'otc/admin/get-market-orders', data, { headers });
  }
  getCoinList() {
    return this.http.get(environment.apiUrl + 'wallet/get-coin-list');
  }
  getBanaxaCurrencyList() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/banxa-admin/transacted-currencies', { headers });
  }
  getTradeOrderList(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/get-orders?pageNo=' + p + '&size=' + ps, { headers });
  }
  hitTradeAPI(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/admin/trades?pageNo=' + p + '&size=' + ps, { headers });
  }
  getTransactionsAPI(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/admin/transactions?pageNo=' + p + '&size=' + ps, { headers });
  }
  getTradeOrderListByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'otc/admin/get-orders-by-filter', data, { headers });
  }
  hitTradeFilterAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/trades-by-filter', data, { headers });
  }
  hitTransactionFilterAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/transactions-by-filter', data, { headers });
  }
  getOfferListByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'otc/admin/get-offers-by-filter', data, { headers });
  }
  getHistoryListByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet-history/get-history-by-filter', data, { headers });
  }
  getTransactionListByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/banxa-admin/get-banxa-transactions-by-filter', data, { headers });
  }

  getOrderBookAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/order-book', data, { headers });
  }

  updateNotificationStatus(id) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'user/admin/update-notification-status?id=' + id, {}, { headers });
  }
  getTransferHistoryByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'quick-transfer/admin/get-quick-transfer-history-by-filter', data, { headers });
  }
  getWalletTransactionDataByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json');
    return this.http.post(environment.apiUrl + 'wallet/admin/get-wallet-transactions-by-filter', data, { headers });
  }
  getHistoryList(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet-history/get-history?page=' + p + '&size=' + ps, { headers });
  }
  getTransactionList(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/banxa-admin/get-banxa-transactions?pageNo=' + p + '&size=' + ps, { headers });
  }
  getReputationRequests() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/admin/get-reputation-requests', { headers });
  }
  getSupportCurrency() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/supported-currency', { headers });
  }
  getSupportAsset() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/supported-asset', { headers });
  }

  getTransactions(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/referral/get-referral-transactions?pageNo=' + p + '&size=' + ps, { headers });
  }
  getContracts() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'ethereum/admin/tokens', { headers });
  }
  getSettings() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'ethereum/admin/setting', { headers });
  }
  getSyncedBlock() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'ethereum/admin/last-synced-block', { headers });
  }
  getUpdationHistory(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/referral/get-setting-updation-history?pageNo=' + p + '&size=' + ps, { headers });
  }
  getAllDeposits(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'ethereum/admin/all-deposits?pageNo=' + p + '&size=' + ps, { headers });
  }
  getAllWithdrawl(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'ethereum/admin/all-withdrawals?pageNo=' + p + '&size=' + ps, { headers });
  }
  getAllSweeps(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'ethereum/admin/all-sweeps?pageNo=' + p + '&size=' + ps, { headers });
  }
  getAllWithdrawForSweeps(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'ethereum/admin/all-withdraw-for-sweep?pageNo=' + p + '&size=' + ps, { headers });
  }
  getWalletTransactionData(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json');
    return this.http.get(environment.apiUrl + 'wallet/admin/get-wallet-transactions?pageNo=' + p + '&size=' + ps, { headers });
  }
  getAccountSummaryData() {

    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet-history/get-account-summary', { headers });



  }
  getFilteredUserList(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'user/admin/get-users-by-filter', data, { headers });
  }
  exportUserFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en').set('responseType', 'blob');
    // this.http.post(apiEndpoint,request,{ responseType: 'blob'} )
    return this.http.post(environment.apiUrl + 'user/admin/download-users-by-filter', data, { headers: headers, responseType: 'blob' });
  }
  approveRejectReputation(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'otc/admin/approve-retrieve-reputation', data, { headers });
  }
  getTransactionByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'user/referral/get-referral-transactions-by-filter', data, { headers });
  }
  getReferralUpdationByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'user/referral/get-setting-updation-history-by-filter', data, { headers });
  }
  getAllDepositsByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'ethereum/admin/all-deposits-by-filter', data, { headers });
  }
  getAllWithdrawlByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'ethereum/admin/all-withdrawals-by-filter', data, { headers });
  }
  getAllSweepsByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'ethereum/admin/all-sweeps-by-filter', data, { headers });
  }
  getAllWithdrawForSweepsByFilter(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'ethereum/admin/all-withdraw-for-sweep-by-filter', data, { headers });
  }
  getOffersOrderList(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/get-offers?pageNo=' + p + '&size=' + ps, { headers });
  }
  getAvailableBanks() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/get-available-banks');
  }
  updatePaymentMethodStatus(id, status) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/update-payment-method-status?id=' + id + '&status=' + status, { headers });
  }
  getAvailablePaymeentMethods() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/get-available-payment-methods', { headers });
  }
  getCountries() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/get-countries');
  }
  getCommissionUserId() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/admin/get-commission-user-id', { headers });
  }
  getCurrencies() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/get-currency-list');
  }
  addUpdateBank(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.post(environment.apiUrl + 'otc/admin/add-or-update-available-bank', data, { headers });
  }
  addUpdateLiquidityCoinCondition(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.post(environment.apiUrl + 'liquidity/add-update-liquidity-user-coin-condition', data, { headers });
  }
  addUpdatePaymentMethod(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.post(environment.apiUrl + 'otc/admin/add-or-update-payment-method', data, { headers });
  }
  getFee() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/get-fee', { headers });
  }
  getFeeUpdateHistory(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/get-fee-updation-history?pageNo=' + p + '&size=' + ps, { headers });
  }
  updateMakerTakerFee(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.post(environment.apiUrl + 'otc/admin/update-maker-taker-fee', data, { headers });
  }
  getRules() {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/get-rules', { headers });
  }
  getRulesUpdateHistory(p, ps) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/get-rules-updation-history?pageNo=' + p + '&size=' + ps, { headers });
  }
  updateRule(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.post(environment.apiUrl + 'otc/admin/update-rule', data, { headers });
  }
  deleteBankAPI(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.get(environment.apiUrl + 'otc/admin/delete-bank?id=' + data.id + '&verificationCode=' + data.verificationCode, { headers });

  }
  getUserdetails(userId) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.get(environment.apiUrl + 'user/admin/get-user-details?userId=' + userId, { headers });
  }

  getUserOrder(payload) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    // tslint:disable-next-line: max-line-length
    return this.http.post(environment.apiUrl + 'otc/admin/get-user-orders', payload, { headers });
  }

  // getrepution(feedback) {
  //   const loggedData = this.getLoggedData();
  //   const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage||'en');
  //   // tslint:disable-next-line: max-line-length
  //   return this.http.get(environment.apiUrl + 'otc/admin/get-feedbacks=' + feedback,{ headers });
  //   }

  getrepution(orderActionId) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/get-feedbacks?feedbackType=' + orderActionId.orderStatus + '&pageNo=' + orderActionId.pageNo + '&size=' + orderActionId.size + '&userId=' + orderActionId.userId, { headers });
  }

  hitGetAllReferralAPI(userId) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/admin/get-invitation-list?userId=' + userId, { headers });
  }
  hitGetAllEarningAPI(userId) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'user/admin/get-referral-earning?userId=' + userId, { headers });
  }
  getWalletListOnUserProfile(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'wallet/admin/get-user-wallet-info?userId=' + data.userId + '&preferredCurrency=USD', { headers });
  }
  obsipay(transfer) {
    const loggedData = this.getLoggedData();
    const apiType = transfer.type == 'sent' ? 'quick-transfer/admin/quick-transfer-sent?' : 'quick-transfer/admin/quick-transfer-received?'
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + apiType + 'pageNo=' + transfer.pageNo + '&size=' + transfer.size + '&userId=' + transfer.userId, { headers });
  }
  getRecentTransaction(transfer) {
    const loggedData = this.getLoggedData();
    const apiType = 'user/admin/get-recent-transactions?'
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'user/admin/get-recent-transactions', transfer, { headers });
    // return this.http.get(environment.apiUrl + apiType + 'pageNo=' + transfer.pageNo + '&size=' + transfer.size + '&userId=' + transfer.userId, { headers });
  }
  getExchangeOpenOrder(transfer) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/user-order-by-id', transfer, { headers });
    // return this.http.get(environment.apiUrl + apiType + 'pageNo=' + transfer.pageNo + '&size=' + transfer.size + '&userId=' + transfer.userId, { headers });
  }
  getExchangeWalletTabData(id) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'exchange/admin/get-balances-by-user-id?userId=' + id, { headers });

  }
  getExchangeTransactionHistory(transfer) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'exchange/admin/trades-by-user-id', transfer, { headers });
    // return this.http.get(environment.apiUrl + apiType + 'pageNo=' + transfer.pageNo + '&size=' + transfer.size + '&userId=' + transfer.userId, { headers });
  }
  // getUserDepositList(data) {
  //   const loggedData = this.getLoggedData();
  //   const apiType = 'wallet/admin/get-user-deposits?'
  //   const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
  //   return this.http.get(environment.apiUrl + apiType + 'coinShortName=' + data.coinShortName + '&userId=' + data.userId, { headers });

  // }
  getUserWithdrawlHistory(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/get-withdrawal-history', data, { headers });

  }
  getUserDepositList(data) {
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.post(environment.apiUrl + 'wallet/admin/get-deposits-history', data, { headers });

  }
  getUserBanxaTransactionList(data) {
    const loggedData = this.getLoggedData();
    const apiType = 'wallet/banxa-admin/get-orders-by-user-id?'
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + apiType + 'asset=' + data.asset + '&userId=' + data.userId + '&pageNo=' + data.pageNo + '&size=' + data.size, { headers });

  }
  getCommissionUserEarningList(data) {
    const loggedData = this.getLoggedData();
    const apiType = 'user/admin/get-commission-user-earning-transaction?'
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + apiType + 'transactionType=' + data.transactionType + '&pageNo=' + data.pageNo + '&size=' + data.size + '&userId=' + data.userId, { headers });

  }
  getBuySellUserOrder(transfer) {
    // https://api-dev.obsidiam.com/v1/otc/admin/get-maker-orders?coinShortName=3&pageNo=2&privateOrder=true&size=2&userId=2
    console.log(transfer)
    const loggedData = this.getLoggedData();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + loggedData.token).set('Content-Type', 'application/json').set('Accept-Language', loggedData.preferredLanguage || 'en');
    return this.http.get(environment.apiUrl + 'otc/admin/get-maker-orders?' + 'pageNo=' + transfer.pageNo + '&privateOrder=' + transfer.privateOrder + '&size=' + transfer.size + '&userId=' + transfer.userId + '&orderStatus=' + transfer.orderStatus, { headers });
  }
}
